module.exports = __webpack_public_path__ + "stylesheets/title-block_2a4adc6506cca5788081e149c97ecbee.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/title-block.less
// module id = 5W2z
// module chunks = 151